export const SWARM_DEFAULTS = {
  site_name: 'SWARM',
  strapline: 'Safer Walking and Riding for Murray Rd',
  logo_url: '/SWARM_logo_no_tagline.svg',
  primary_color: '#ce3c2a',
  accent_color: '#ce3c2a',
  header_background: '#ffffff',
  header_text: '#2d2d2d',
  button_primary_bg: '#ce3c2a',
  button_primary_text: '#ffffff',
};

export function normalizeBrandingConfig(config) {
  if (!config) {
    return { ...SWARM_DEFAULTS };
  }

  return {
    ...config,
    site_name: config.site_name || config.siteName || SWARM_DEFAULTS.site_name,
    logo_url: config.logo_url || config.logoUrl || SWARM_DEFAULTS.logo_url,
    strapline: config.strapline || SWARM_DEFAULTS.strapline,
    primary_color: config.primary_color || config.primaryColor || SWARM_DEFAULTS.primary_color,
    accent_color: config.accent_color || config.accentColor || SWARM_DEFAULTS.accent_color,
    header_background:
      config.header_background || config.headerBackground || SWARM_DEFAULTS.header_background,
    header_text: config.header_text || config.headerTextColor || SWARM_DEFAULTS.header_text,
    button_primary_bg:
      config.button_primary_bg || config.buttonPrimaryBg || SWARM_DEFAULTS.button_primary_bg,
    button_primary_text:
      config.button_primary_text || config.buttonPrimaryText || SWARM_DEFAULTS.button_primary_text,
    font_family: config.font_family || config.fontFamily || 'Inter',
    font_weights: config.font_weights || config.fontWeights || ['400', '500', '600', '700'],
  };
}

export function SwarmLogoImage({ brandingConfig, className = 'w-12 h-12', testId }) {
  const src = brandingConfig?.logo_url || SWARM_DEFAULTS.logo_url;
  return (
    <img src={src} alt="SWARM logo" className={`flex-shrink-0 ${className}`} data-testid={testId} />
  );
}
